import { ButtonType, ButtonWidget, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { CreateCustomDialogFn, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { UploadWorkbookStyles } from '../styles/UploadWorkbookStyles';

export interface OverwriteConfirmDialogProps {
  title: string;
  warningMessage: string;
  onSubmit: () => void;
  onCancel: () => void;
  close: () => void;
}
/**
 * Options used for ReactModalService
 */
export function OverwriteConfirmDialogOpts(props: Omit<OverwriteConfirmDialogProps, 'close'>, testId: string): CreateCustomDialogFn {
  return (closeAndDismiss) => {
    const dialogProps = ReactModalService.getDefaultDialogProps({
      type: DialogType.NormalWithTitleBar,
      title: props.title,
      showCloseButton: false,
      dialogWidth: 400,
      shouldNotCloseOnGlassClick: true,
      testId
    }, closeAndDismiss);

    return (
      <DialogWidget {...dialogProps}>
        <OverwriteConfirmDialog
          title={props.title}
          warningMessage={props.warningMessage}
          onSubmit={props.onSubmit}
          onCancel={props.onCancel}
          close={closeAndDismiss.close}
        />
      </DialogWidget>
    );
  };
}

export class OverwriteConfirmDialog extends React.PureComponent<OverwriteConfirmDialogProps> {

  private handleSubmit = (): void => {
    this.props.onSubmit();
    this.props.close();
  };

  private handleCancel = (): void => {
    this.props.onCancel();
    this.props.close();
  };

  render() {
    return (
    <div>
        {this.props.warningMessage}

        <footer className={UploadWorkbookStyles.footer}>
          <ButtonWidget
            buttonType={ButtonType.Outline}
            testId={'confirm-overwrite-dialog-cancel'}
            children={Messages.cancel()}
            handleClick={this.handleCancel}
          />
          <ButtonWidget
            buttonType={ButtonType.Primary}
            testId={'confirm-overwrite-dialog-submit'}
            children={Messages.contentUpload_overwrite()}
            handleClick={this.handleSubmit}
          />
        </footer>
      </div>
    );
  }
}
